import { MessageHandlerActionsCreator } from "DistributedTaskControls/Actions/MessageHandlerActionsCreator";
import { ActionCreatorManager } from "DistributedTaskControls/Common/Actions/ActionCreatorManager";
import { ActionsHubManager } from "DistributedTaskControls/Common/Actions/ActionsHubManager";
import * as ActionBase from "DistributedTaskControls/Common/Actions/Base";

import { MessageBarType } from "OfficeFabric/MessageBar";

import { DefinitionsActionsCreatorKeys, MessageBarParentKeyConstants, AllDefinitionsContentKeys } from "PipelineWorkflow/Scripts/Definitions/Constants";
import { DefinitionsActionsHub } from "PipelineWorkflow/Scripts/Definitions/DefinitionsActions";
import { DefinitionsSource } from "PipelineWorkflow/Scripts/Definitions/DefinitionsSource";
import { DefinitionsUtils } from "PipelineWorkflow/Scripts/Definitions/Utils/DefinitionsUtils";
import * as PipelineTypes from "PipelineWorkflow/Scripts/Common/Types";
import { PermissionHelper, IPermissionCollection } from "PipelineWorkflow/Scripts/SharedComponents/Security/PermissionHelper";
import { SecurityUtils } from "PipelineWorkflow/Scripts/Editor/Common/SecurityUtils";
import * as Diag from "VSS/Diag";
import { PermissionEvaluationBatch, PermissionEvaluation } from "VSS/Security/Contracts";

export class DefinitionsActionsCreator extends ActionBase.ActionCreatorBase {

    public static getKey(): string {
        return DefinitionsActionsCreatorKeys.ActionCreatorKey_DefinitionsActionsCreator;
    }

    public initialize(instanceId?: string): void {
        this._definitionsActionsHub = ActionsHubManager.GetActionsHub<DefinitionsActionsHub>(DefinitionsActionsHub);
        this._messageHandlerActionsCreator = ActionCreatorManager.GetActionCreator<MessageHandlerActionsCreator>(MessageHandlerActionsCreator);
    }

    public fetchFolders(): void {
        DefinitionsSource.instance().getReleaseDefinitionsFolders().then((folders: PipelineTypes.PipelineDefinitionFolder[]) => {
            this._definitionsActionsHub.foldersInitialized.invoke({ folders: folders });
            this._updateFolderPermissions(folders);
        },
            (error) => {
                this._handleError(error);
            });
    }

    private _updateFolderPermissions(folders: PipelineTypes.PipelineDefinitionFolder[]): void {
        if (!folders || folders.length === 0) {
            return;
        }

        let permissionsBatch: PermissionEvaluationBatch = {
            alwaysAllowAdministrators: true,
            evaluations: []
        };

        folders.forEach((folder: PipelineTypes.PipelineDefinitionFolder) => {
            const token: string = SecurityUtils.createFolderPathSecurityToken(folder.path);

            DefinitionsUtils.addRMPermissionEvaluations(permissionsBatch.evaluations, token);
        });

        PermissionHelper.fetchPermissions(permissionsBatch).then((permissions: IPermissionCollection) => {
            this._definitionsActionsHub.updateFolderPermissions.invoke(permissions);
        });
    }

    private _handleError(error: string): void {
        let errorMessage: string = this._getErrorMessage(error);
        if (errorMessage) {
            Diag.logError(errorMessage);
            this._messageHandlerActionsCreator.addMessage(MessageBarParentKeyConstants.DefinitionsHubErrorMessageBarKey, errorMessage, MessageBarType.error);
        }
    }

    private _getErrorMessage(error): string {
        if (!error) {
            return null;
        }

        return error.message || error;
    }

    private _definitionsActionsHub: DefinitionsActionsHub;
    private _messageHandlerActionsCreator: MessageHandlerActionsCreator;
}